import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '../../services/maintenance.service';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';



@Component({
  selector: 'app-maintanence',
  templateUrl: './maintanence.component.html',
  styleUrls: ['./maintanence.component.css']
})
export class MaintanenceComponent implements OnInit {
  toggleValue = false;
  maintenance_status;
  maintenance_alerts;
  maintenanceMode: string;
  date: Date = new Date();
  settings = {
    bigBanner: true,
    timePicker: true,
    format: 'dd/MM/yyyy hh:mm a'
  };
  api_success: string;
  api_error: any;
  btndisabled = false;
  constructor(private maintenanceService: MaintenanceService, private datePipe: DateFormatPipe) {
    this.maintenanceService.getStatus().subscribe(res => {
      this.maintenance_status = res;
      if (res) {
        this.maintenanceMode = 'Maintenance Started';
      } else {
        this.maintenanceMode = 'Maintenance Stopped';
      }
    });
  }
  ngOnInit() {
  }
  onChange() {
    this.toggleValue = !this.toggleValue;
  }
  sendAlerts() {
    this.api_success = '';
    this.api_error = '';
    this.btndisabled = true;
    const obj = {
      'maintenanceOn': this.datePipe.transformToLocalDate(this.date),
      'maintenanceTime': this.datePipe.transformToLocalTime(this.date)
    };
    this.maintenanceService.sendAlerts(obj)
      .subscribe(res => {
        if (res) {
          setTimeout(() => {
            this.api_success = 'Maintenance Alerts Send Successfully';
            this.date = new Date();
            this.maintenance_alerts = false;
            this.toggleValue = false;
          }, 2000);
          this.btndisabled = false;
        }
      }, (error => {
        this.api_error = error.error;
        this.btndisabled = false;
      }));
  }
  change_maintenance_status() {
    if (this.maintenance_status) {
      this.maintenanceMode = 'Maintenance Started';
    } else {
      this.maintenanceMode = 'Maintenance Stopped';
    }
    this.maintenanceService.updateStatus(this.maintenance_status)
      .subscribe(res => {
      });
  }
}
